import React from "react";
import useReveal from "@/lib/useReveal";

export default function Reveal({ as = "div", children, delay = 0, className = "", direction = "up", ...rest }) {
  const [ref, shown] = useReveal();
  const Comp = as;
  const offset = direction === "left" ? "-translate-x-6" : direction === "right" ? "translate-x-6" : "translate-y-6";
  return (
    <Comp
      ref={ref}
      style={{ transitionDelay: shown ? `${delay}ms` : "0ms" }}
      className={`${className} transition-all duration-[700ms] ease-out motion-reduce:transition-none ${shown ? "opacity-100 translate-x-0 translate-y-0" : `opacity-0 ${offset}`}`}
      {...rest}
    >
      {children}
    </Comp>
  );
}
